import SitecoreTextModel from '@models/SitecoreTextModel';

const TEXT_ARR = [
  'Color Label',
  'Order Number Label',
  'Order Placed Label',
  'Unknown Text'
];

export default class ProductDetailModel {
  constructor() {
    TEXT_ARR.forEach((item) => {
      this[item] = new SitecoreTextModel();
    });
  }
  getData(dataSource) {
    TEXT_ARR.forEach((item) => {
      if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, item)) {
        this[item] = dataSource[item] ?? this[item];
      }
    });

    return this;
  }
}
